/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-trailing-spaces */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { HiOutlineBars3 } from 'react-icons/hi2';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { RiContactsLine, RiLoginBoxLine, RiRefund2Fill, RiFilterLine, RiEyeLine, RiFilePaperFill } from 'react-icons/ri'; // RiUser4Line
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to the '/about' page
    navigate('https://242306328.hs-sites-na2.com/contact');
  };
  const [openMenu, setOpenMenu] = useState(false);
  let currentHostname = `${window.location.protocol}//${window.location.hostname}`;
  if (currentHostname.includes('localhost')) {
    currentHostname += ':3001/login';
  } else if (currentHostname.includes('dev.zackatlabs.com')) {
    currentHostname = 'https://monaco.zackat.com/login';
  } else if (currentHostname.includes('beta.zackatlabs.com')) {
    currentHostname = 'https://staging.zackatlabs.com/login';
  } else if (currentHostname.includes('www.zackatlabs.com')) {
    currentHostname = 'https://app.zackatlabs.com/login';
  } else if (currentHostname.includes('zackatlabs.com')) {
    currentHostname = 'https://app.zackatlabs.com/login';
  }

  const menuOptions = [
    {
      text: 'Login',
      icon: <RiLoginBoxLine />,
      url: 'https://prod.zackatlabs.com/login',
    },
    {
      text: 'About',
      icon: <RiEyeLine />,
      url: 'https://242306328.hs-sites-na2.com/about-leadership',
    },
    {
      text: 'Solutions',
      icon: <RiFilterLine />,
      url: 'https://242306328.hs-sites-na2.com/solution',
    },
    {
      text: 'Technology',
      icon: <RiRefund2Fill />,
      url: 'https://242306328.hs-sites-na2.com/technology',
    },

    {
      text: 'Contact',
      icon: <RiContactsLine />,
      url: 'https://242306328.hs-sites-na2.com/contact',
    },
    {
      text: 'Resources',
      icon: <RiFilePaperFill />,
      url: 'https://242306328.hs-sites-na2.com/resources',
    },
  ];
  return (
    <div className="control-container">
      <nav>
        <div className="child-div">
          <a href="/"> 
            <img src="zackatlabs.jpeg" width="100px" alt="" />
          </a>
        </div>
        <div className="navbar-links-container">
          <a href={currentHostname} target="_blank" rel="noreferrer">Login</a>
          <a href="https://242306328.hs-sites-na2.com">About</a>
          <a href="https://242306328.hs-sites-na2.com/solution" target="_blank" rel="noreferrer">Solutions</a>
          <a href="https://242306328.hs-sites-na2.com/technology">Technology</a>
          <a href="https://242306328.hs-sites-na2.com/contact">Contact</a>
          <a href="https://242306328.hs-sites-na2.com/resources">Resources</a>
          <button type="button" className="primary-button monacoltgrn" onClick={handleClick}>Get a DEMO</button>
        </div>
        <div className="navbar-menu-container">
          <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
        </div>
        <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={() => setOpenMenu(false)}
            onKeyDown={() => setOpenMenu(false)}
          >
            <List>
              {menuOptions.map((item) => (
                <ListItem key={item.text} disablePadding component="a" href={item.url}>
                  <ListItemButton>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.text} href={item.url} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            <Divider />
          </Box>
        </Drawer>
      </nav>
    </div>
  );
};

export default Navbar;
